import apiHeader from '@/helpers/apiHeader';

const sapSyncService = {
	list(params) {
    	return apiHeader.get('sap/sap-configuration', {params});
	},
	get(sap_sync) {
    	return apiHeader.get(`sap/sap-configuration/${sap_sync}`);
	},
	create(params) {
    	return apiHeader.post('sap/sap-configuration', params);
	},
	update(sap_sync, params) {
    	return apiHeader.put(`sap/sap-configuration/${sap_sync}`, params);
	},
	delete(sap_sync) {
    	return apiHeader.delete(`sap/sap-configuration/${sap_sync}`);
	},
	getSapSyncParams(sap_sync) {
		return apiHeader.get(`sap/sap-configuration-params/${sap_sync}`);
	}
};

export default sapSyncService;
